<template>
  <v-layout
    fill-height
    wrap
  >
    <v-flex xs12>
      <LargeBookForm
        v-if="bookingForm"
        :update-mode="updateMode"
        :booking-form="bookingForm"
        @cancelledBooking="cancelledBooking"
        @rideConfirmed="rideConfirmed"
      />
    </v-flex>
  </v-layout>
</template>

<script>
// @ is an alias to /src

import LargeBookForm from "@/components/booking/form/LargeUpdateBookForm.vue";
import { BookingForm } from "@/components/util/BookingForm.js";
import BookingActions from "@/components/widget/input/MessageCustomerMenu.vue";



import axios from "axios";
axios.defaults.withCredentials = true;
export default {
  name: "BookingDetails",
  components: {
    LargeBookForm,
    BookingActions
  },
  data: function () {
    return {
      updateMode: true,
      currentBookingID: '',
      bookingForm: '',
      editBookingError: '',
      rideTypes: [],
      loadingEditBooking: false,
      showMessageSupplierDialog: false,
    };
  },
  watch: {
    reloadBooking () {
      if (this.reloadBooking) {
        this.goToBooking(this.$route.params.id)
      }
    }
  },
  computed: {
    booking () {
      return this.$store.getters['booking/getBooking']
    },
    reloadBooking () {
      return this.$store.getters['booking/getReloadBooking']
    },
    bookingFormCached () {
      if (this.booking) {
        var bookingUser = BookingForm.jsonToBookingFormBookingUser(this.booking);
        let bookingForm = new BookingForm(
            this.rideTypes,
            bookingUser,
            this.$store
        );
        return bookingForm
      }
      return null
    }
  },
  created: function () {
    console.log(this.$route.params.id)
    this.$store.dispatch('booking/getBooking', this.$route.params.id)
  },
  mounted: function () {
    this.getRideTypes()
    this.goToBooking(this.$route.params.id)
  },
  methods: {
    rideConfirmed() {
      this.$store.dispatch('unconfirmedBooking/confirm', this.$route.params.id).then(res => {
        this.$snackbar.success('Booking confirmed')
        this.goToBooking(this.$route.params.id)
      })
    },
    getChipColor(state) {
      if (state == 'cancelled') {
        return 'red lighten-4'
      }
      if (state == 'completed') {
        return 'green lighten-4'
      }
      if (state == 'booked') {
        return 'blue lighten-4'
      }
      return null
    },
    getChipTextColor(state) {
      if (state == 'cancelled') {
        return 'red--text'
      }
      if (state == 'completed') {
        return 'green--text'
      }
      if (state == 'booked') {
        return 'blue--text'
      }
      return null
    },
    goToUser: function (id) {
      window.open(`/customer/view/${id}`, "_blank");
    },
    async getBookingForEdit(bookingID) {
      // this.loadingEditBooking = true;
      this.$loadingDialog.show()
      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {}
        });

        this.$loadingDialog.hide()
        this.$store.commit('booking/setReloadBooking', false)
        // this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          console.log('response booking, ', response.data)
          console.log('response booking, ', response.data)
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.$loadingDialog.hide()
        // this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    cancelEditBooking: function(reload) {
      return this.$router.push('bookings')
      console.log("Hiding booking dialog");
      this.bookingForm = null;

      this.loadingEditBooking = true;
      this.editBookingError = null;
      this.viewBookingDialog = false;

      if (reload != false) {
        this.$emit("reload", null);
      }
    },
    cancelledBooking() {
      console.log("Booking cancelled");
      var vm = this;
      this.cancelEditBooking();
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        this.getRepeatService();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    goToBooking: function(id) {
      // this.cancelEditBooking(false);

      this.currentBookingID = id;

      var vm = this;

      vm.$nextTick(async function() {
        // this.viewBookingDialog = true;

        var booking = await vm.getBookingForEdit(id);


        console.log("booking");
        if (booking.payment_intent) {
          console.log("payment_intent", (JSON.parse(booking.payment_intent)));
        }
        console.log(booking);

        if (typeof booking === "string") {
          console.log("Error for edit booking");
          this.editBookingError = booking;
          alert(this.editBookingError);
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
              this.rideTypes,
              bookingUser,
              this.$store
          );
          // this.$store.commit('booking/setBookingForm', this.bookingForm)
          // window.open('/bookings/' + booking.booking.id, '_blank')
          // return this.$router.push('bookings/' + booking.booking.id)
        }

        // this.loadingEditBooking = false;
      });
    },
  },
};
</script>
